import { Descriptions, Spin, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCompletedTaskDetails } from "../../app/api";
import { useCompletedTasksContext } from "../../context/CompletedTasksContext";

const { Text } = Typography;

const CompletedTaskDetails = () => {
    const { taskId } = useParams();
    const [loading, setLoading] = useState(true);
    const { completedTaskDetailsData, setCompletedTaskDetailsData } = useCompletedTasksContext();

    const productsColumns = [
        {
            title: 'Անվանում',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Քանակ',
            dataIndex: 'count',
            key: 'count',
            render: (count) => (count || 1) ?? "Չի նշված",
        },
        {
            title: 'Ինքնարժեք',
            dataIndex: 'cost',
            key: 'cost',
            render: (cost, record) => {
                if (cost != null) {
                    const totalCost = record.count ? cost * record.count : cost;
                    return `${cost} ֏ (${totalCost} ֏)`;
                }
                return "Չի նշված";
            },
        },
        {
            title: 'Վաճառքի գին',
            dataIndex: 'price',
            key: 'price',
            render: (price, record) => {
                if (price != null) {
                    const totalPrice = record.count ? price * record.count : price;
                    return `${price} ֏ (${totalPrice} ֏)`;
                }
                return "";
            },
        }
    ];

    const items = [
        {
            key: '1',
            label: 'Օգտատերի Անուն',
            children: completedTaskDetailsData?.username  || "Նյութերը չեն գտնվել",
        },
        {
            key: '2',
            label: 'Օգտատերի Հեռախոսահամարը',
            children: completedTaskDetailsData?.mobile || "Մուտք չի կատարվել",
        },
        {
            key: '3',
            label: 'Հասցեն',
            children: completedTaskDetailsData?.location || "Անհայտ",
        },
        {
            key: '4',
            label: 'Մեքենայի Տեսակը',
            children: (completedTaskDetailsData?.car ? completedTaskDetailsData?.car.make : completedTaskDetailsData?.auto_name) || "Անհայտ",
        },
        ...(
            completedTaskDetailsData?.car && completedTaskDetailsData?.car?.model 
            ? [{
                key: '5',
                label: 'Մոդելը',
                children: completedTaskDetailsData?.car.model || completedTaskDetailsData?.model || "Անհայտ",
            }] 
            : []
        ),
        {
            key: '6',
            label: 'Մեքենայի համարանիշ',
            span: !(completedTaskDetailsData?.car?.model || completedTaskDetailsData?.model) ? 3 : 1,
            children: completedTaskDetailsData?.car?.car_number || completedTaskDetailsData?.car_number || "Անհայտ",
        },        
        ...(
            completedTaskDetailsData?.car && completedTaskDetailsData?.car.win_number 
            ? [{
                key: '7',
                label: 'VIN համարը',
                span: 3,
                children: <Text copyable>{completedTaskDetailsData.car.win_number}</Text>,
            }] 
            : []
        ),
        {
            key: '8',
            label: 'Աշխատանքի Անունը',
            span: 3,
            children: completedTaskDetailsData?.work_name?.length 
                ? completedTaskDetailsData.work_name.join(", ") 
                : "Անհայտ",
        },
        {
            key: '9',
            label: 'Կատարված Աշխատանքը',
            span: 3,
            children: completedTaskDetailsData?.description || "Անհայտ",
        },
        {
            key: '10',
            label: 'Ընդհանուր Աշխատանքի Գումարը',
            span: 3,
            children: completedTaskDetailsData?.totalAmount !== undefined 
                ? (
                    <strong style={{ color: 'red', fontSize: '16px' }}>
                        {new Intl.NumberFormat('hy-AM', { style: 'currency', currency: 'AMD' }).format(completedTaskDetailsData.totalAmount)}
                    </strong>
                ) 
                : "Անհայտ",
        },
        {
            key: '11',
            label: 'Հաճախորդի համար',
            span: 3,
            children: completedTaskDetailsData?.products?.length ? (
                <span
                    style={{ cursor: 'pointer', fontSize: '18px' }}
                    onClick={() => window.open(`/products/${taskId}`, '_blank')}
                >
                    Տեսնել ավելին ➡️
                </span>
            ) : "Անհայտ",
        },
        {
            key: '12',
            label: 'Ապրանքներ',
            children: completedTaskDetailsData?.products?.length ? (
                <Table
                    columns={productsColumns}
                    dataSource={completedTaskDetailsData.products}
                    pagination={false}
                    rowKey="id"
                    size="small"
                    bordered={true}
                    footer={() => {
                        const totalCost = completedTaskDetailsData.products.reduce((sum, record) => sum + (record.cost * record.count || record.cost), 0);
                        const totalPrice = completedTaskDetailsData.products.reduce((sum, record) => sum + (record.price * record.count || record.price), 0);
                    
                        return (
                            <div style={{ display: 'flex', color: "red", justifyContent: 'space-between' }}>
                                <div>Ընդհանուր</div>
                                <div />
                                <div>{totalCost} ֏</div>
                                <div>{totalPrice} ֏</div>
                            </div>
                        );
                    }}
                />
            ) : "Անհայտ",
        }                   
    ];

    const fetchCompletedTaskDetails = async () => {
        setLoading(true);
        try {
            const allData = await getCompletedTaskDetails(taskId);
            if (allData.status === 200) {
                setCompletedTaskDetailsData(allData.data);
            }
        } catch (error) {
            console.error("Failed to fetch car details", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchCompletedTaskDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <Spin size="large" />
                <p>Տվյալները բեռնվում են...</p>
            </div>
        );
      }
    
    
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <Descriptions title="Պատվերի մանրամասներ" layout="vertical" items={items} />
        </div>
    )
}

export default CompletedTaskDetails;